export default "__VITE_ASSET__DcNfTxRd__"